import { ClusterRepository } from './cluster.repository'

const clusterRepository = new ClusterRepository()
export { clusterRepository }
